import { useQuery } from '@apollo/client';
import { useSelector } from 'react-redux';
import { useDebounce } from 'hooks/useDebounce';
import { Account } from '@trnsact/trnsact-shared-types';
import { APIRequestPagination, APIRequestSort } from 'global';

import { customersApi } from '../api';
import { formatCustomersToTableData } from '../lib';

export function useCustomersPage(searchTerm: string, pagination: APIRequestPagination, sorting?: APIRequestSort) {
  const account = useSelector((state: any) => state.account) as Account;

  const debouncedSearchTerm = useDebounce(searchTerm);

  const { data, loading, previousData } = useQuery(customersApi.getCustomers, {
    notifyOnNetworkStatusChange: true,
    variables: {
      input: {
        accountId: account.id,
        pagination: {
          page: pagination.page,
          perPage: pagination.perPage,
        },
        searchTerm: debouncedSearchTerm.trim().length > 2 ? debouncedSearchTerm : undefined,
        sorting,
      },
    },
  });

  const response = (data ?? previousData)?.customer?.customersByAccountId;

  return {
    isLoading: loading,
    total: response?.pagination?.total ?? 0,
    customers: formatCustomersToTableData(response?.items ?? []),
  };
}
